module.exports = __webpack_public_path__ + "static/media/nutricia-brand-allergens-eggs.e055bcd4.svg";